import type { FaireProductEntity } from "../../entity_types/product";

export const p_z2ewfdq563: FaireProductEntity = {
  token: "p_z2ewfdq563",
  type: "product",
  name: "Canvas Tote, Little Libraries",
  brandToken: "b_2io333ig7s",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/0ef9595050345bde8522f494090749da6df3d3f1723d437e93bb8c20df297918.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e66b5ef4c1ff79b8874753c73b220dce55152ddba1780e3bc96ebe3ef2e074e9.jpeg",
    "https://cdn.faire.com/fastly/f56bea1694ddc59a7980012c6edc1588b540f69a34036b456e5ae682d68ea87c.jpeg"
  ],
  priceDollars: 13.82,
  description: "You know what you’re passionate about—and it just so happens to be little libraries. This canvas tote features a colorful, book-inspired design and a comfortable shoulder strap, making it perfect for carrying your latest reads, notebooks, or daily essentials.\n\nFeatures:\n\nMade with durable cotton canvas\n\nFeatures a bright, book-themed design\n\nIncludes a shoulder strap for easy carrying\n\nSpacious and sturdy—perfect for books, groceries, or errands\n\nDesigned in Bando’s signature cheerful and creative style\n\n\nIdeal For:\n\nGift shops and bookstores\n\nLifestyle and accessory retailers\n\nReaders, students, and library lovers\n\nWholesale buyers seeking cute, meaningful totes",
  tags: [],
  msrpDollars: 27.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:00.222Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
